import PropTypes from 'prop-types';
import React from 'react';

export const ProductHeader = ({ headline }) => {
    if (!headline) {
        return null;
    }

    return (
        <div className="products-head">
            <div className="head-caption">
                <h2>{headline}</h2>
            </div>
        </div>
    );
};